import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_PROCESS} from '../../metamodel/Concept';

export default class ApplicationProcessNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_PROCESS;
	}
}
